import { HardDecline, useWizard } from '@insify/funnel-components';
import { useTranslation } from 'react-i18next';

import { useContent } from '../../hooks/useContent';

export const HardDeclinePage = (): JSX.Element | null => {
  const { t } = useTranslation(['common']);
  const { showPreviousPage } = useWizard();
  const { hardDecline } = useContent() || {};

  return (
    <HardDecline
      content={hardDecline}
      previousButtonCopy={t('common:back')}
      eventHandlers={{
        onBack: showPreviousPage,
      }}
    />
  );
};
